import React, { useEffect, useContext } from 'react';

import { useNavigate } from 'react-router-dom';

import Layout from '../components/common/Layout';
import { UserContext } from '../context/UserContext';
import { getApplicationId } from '../helpers/applicationHelp';
import { getApplication } from '../service/api';

export const LoanDetail = () => {
  const navigate = useNavigate();
  const { appData, updateAppData } = useContext(UserContext);

  const timeout = 1000 * 5;
  useEffect(() => {
    const timer = setInterval(async () => {
      const res = await getApplication();
      if (res && res.data) {
        updateAppData(res.data);
      }
    }, timeout);

    return () => {
      clearInterval(timer);
    };
    // eslint-disable-next-line
  }, []);

  const handleSubmit = async () => {
    return navigate('/dashboard');
  };

  return (
    <Layout>
      <div className="loan-details">
        <div className="loan-details-header">
          <h1 className="title">Grant details</h1>
        </div>
        <div className="d-flex loan-detail-app-info">
          <div className="d-flex">
            <div className="main-text">
              <h3>Application Number: {getApplicationId(appData, false)}</h3>
            </div>
          </div>
        </div>
        <div className="need-docs-header">
          <h1 className="title">What happens next?</h1>
          <h3 className="subtitle">Funding usually happen within a few days</h3>
        </div>
        <div className="actions">
          <button className="primary-btn" onClick={handleSubmit}>
            Go to Dashboard
          </button>
        </div>
      </div>
    </Layout>
  );
};
